exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".header-links{cursor:pointer;margin:10px;text-decoration:none;font-size:17px;font-weight:bold;letter-spacing:1.4px}.header-links:hover{text-decoration:none}.product-div .filterDropdown{background:#fff 0% 0% no-repeat padding-box;box-shadow:0px 1px 3px rgba(0,0,0,.2);border-radius:4px;opacity:1;width:157px;font-size:14px;height:56px}.product-div .filterDropdown .MuiFilledInput-input{padding-top:18px !important}.action-button-position{position:absolute;z-index:100;top:168px}.case-table{padding-top:35px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/Home/AdvisorWelcome.scss
// module id = 7509
// module chunks = 101